import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'config/theme/baseTheme';

export const useStyles = makeStyles(() => ({
  virtualProductLabel: {
    fontSize: 12,
  },
  badge: {
    backgroundColor: COLORS.CREAM_CAN,
    color: COLORS.BLACK,
    padding: '2px 8px',
    borderRadius: '12px 0px 12px 0px',
    fontSize: 12,
    fontWeight: 700,
    display: 'inline-block',
    lineHeight: '16px',
    marginTop: 4,
  },
}));
